import AiToolPanel from "@/components/ai/AiToolPanel";

const examples = [
  {
    label: "Top customers",
    value: "Top 10 customers by total order amount in the last 90 days. Tables: customers(id,name), orders(id,customer_id,total,created_at).",
  },
  {
    label: "Daily signups",
    value: "Count of users who signed up per day for the last 30 days, including days with zero signups (PostgreSQL).",
  },
  {
    label: "Inactive accounts",
    value: "Find accounts with no login in the past 60 days but who have an active subscription.",
  },
];

const SqlBuilder = () => (
  <AiToolPanel
    task="sql-build"
    inputLabel="Describe the query in plain English"
    placeholder="Include table/column names if you know them, plus any filters, joins or aggregations you want."
    buttonLabel="Build SQL"
    rows={8}
    examples={examples}
  />
);

export default SqlBuilder;